import { useIsAuth } from 'feature/auth/hooks'
import { authActions } from 'feature/auth/redux/authSlice'
import { isLkmDomain } from 'router/utils'
import { useEffect } from 'react'
import { useAppDispatch } from 'store/hooks'
import { useGetMainPageDataQuery } from '../redux/user.api'
import { useGetFitterQuery } from '../redux/fitter.api'
import { skipToken } from '@reduxjs/toolkit/query/react'
import { UserMainPage } from '../types'

export const useGetUserData = () => {
  const isAuth = useIsAuth()
  const isLkm = isLkmDomain()
  const dispatch = useAppDispatch()

  const mainPageResult = useGetMainPageDataQuery(
    isAuth && !isLkm ? undefined : skipToken,
  )

  const fitterResult = useGetFitterQuery(
    isAuth && isLkm ? undefined : skipToken,
  )

  const isLkmMode = isAuth && isLkm
  const isRegularMode = isAuth && !isLkm

  const data = isLkmMode ? fitterResult.data : mainPageResult.data
  const isLoading = isLkmMode
    ? fitterResult.isLoading
    : mainPageResult.isLoading
  const isFetching = isLkmMode
    ? fitterResult.isFetching
    : mainPageResult.isFetching
  const isError = isLkmMode ? fitterResult.isError : mainPageResult.isError
  const error = isLkmMode ? fitterResult.error : mainPageResult.error

  // Сохраняем clientType в Redux + localStorage при получении данных профиля
  useEffect(() => {
    if (!mainPageResult.data) return
    const clientType = (mainPageResult.data as UserMainPage | undefined)
      ?.clientType
    dispatch(authActions.setClientTypeInfo(clientType ?? null))
  }, [mainPageResult.data])

  return {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    isLkmUser: isLkmMode,
    isRegularUser: isRegularMode,
  }
}
